<template>
  <modal name="dimensionModal" height="auto" width="700" :scrollable="true" :clickToClose="false">
    <CloseModal :close="close" />
    <div class="fm">
      <div class="fm-title">{{ isEditing ? 'Editar' : 'Nova' }} Dimensão / Catálogo</div>

      <div class="row">
        <div class="col-md-4">
          <label class="fm-label">Eixo/Coluna (produto.dimensaoN)</label>
          <input type="number" class="form-control form-control-sm fm-input-mono" v-model.number="form.coluna" placeholder="Ex: 2" />
        </div>
        <div class="col-md-5">
          <label class="fm-label">Rótulo do eixo</label>
          <input type="text" class="form-control form-control-sm" v-model="form.dimensao_label" placeholder="Ex: CATALOGO" />
        </div>
        <div class="col-md-3">
          <label class="fm-label">Ativo</label>
          <select class="form-control form-control-sm" v-model="form.is_active">
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
      </div>

      <div class="mt-3">
        <label class="fm-label">Endpoint da fonte</label>
        <input type="text" class="form-control form-control-sm fm-input-mono" v-model="form.source_endpoint" placeholder="Ex: ItemProperties" />
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <label class="fm-label">Campo ID</label>
          <input type="text" class="form-control form-control-sm fm-input-mono" v-model="form.id_field" placeholder="Ex: Number" />
        </div>
        <div class="col-md-6">
          <label class="fm-label">Campo Descrição</label>
          <input type="text" class="form-control form-control-sm fm-input-mono" v-model="form.descricao_field" placeholder="Ex: PropertyName" />
        </div>
      </div>

      <div class="mt-3">
        <label class="fm-label">Filtro base (OData)</label>
        <textarea class="form-control form-control-sm fm-input-mono" rows="2" v-model="form.base_filter" placeholder="Opcional. Ex: Active eq 'tYES'"></textarea>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <label class="fm-label">Só valores referenciados</label>
          <select class="form-control form-control-sm" v-model="form.only_referenced">
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="fm-label">Ordem</label>
          <input type="number" class="form-control form-control-sm" v-model.number="form.sort_order" />
        </div>
      </div>

      <div class="fm-help mt-3">
        <strong>Dimensão / Catálogo:</strong> Configura o produtor de dimensões (<code>erp_dimension_config</code>).
        Cada valor do endpoint <code>{{ form.source_endpoint || 'fonte' }}</code> vira uma opção do eixo
        <code>produto.dimensao{{ form.coluna || 'N' }}</code>, usando <code>{{ form.id_field || 'id' }}</code> como
        identificador e <code>{{ form.descricao_field || 'descrição' }}</code> como rótulo.
        Com <strong>"Só valores referenciados"</strong> ativo, apenas os valores realmente usados pelos produtos são carregados.
      </div>

      <div class="fm-footer">
        <button class="btn btn-sm btn-secondary" @click="close">Cancelar</button>
        <button class="btn btn-sm btn-primary" @click="save" :disabled="!canSave || saving">Salvar</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { post, put } from "../../../helpers/apiRequest";
import CloseModal from "../../../components/CloseModal";

export default {
  name: "DimensionModal",
  components: { CloseModal },
  data() {
    return {
      isEditing: false,
      editId: null,
      saving: false,
      form: this.emptyForm(),
    };
  },
  computed: {
    canSave() {
      return !!(this.form.coluna && this.form.source_endpoint && this.form.id_field && this.form.descricao_field);
    },
  },
  methods: {
    emptyForm() {
      return {
        coluna: null,
        source_endpoint: "",
        id_field: "",
        descricao_field: "",
        dimensao_label: "CATALOGO",
        base_filter: "",
        only_referenced: true,
        is_active: true,
        sort_order: 0,
      };
    },
    open(data) {
      if (data && data.id) {
        this.isEditing = true;
        this.editId = data.id;
        this.form = { ...this.emptyForm(), ...data };
      } else {
        this.isEditing = false;
        this.editId = null;
        this.form = this.emptyForm();
      }
      this.saving = false;
      this.$modal.show("dimensionModal");
    },
    close() { this.$modal.hide("dimensionModal"); },
    save() {
      if (!this.canSave || this.saving) return;
      this.saving = true;
      const req = this.isEditing
        ? put(`/admin/erp-dimension-configs/${this.editId}`, this.form)
        : post("/admin/erp-dimension-configs", this.form);
      req.then(() => { this.$emit("saved"); this.close(); })
        .catch(err => { this.$swal && this.$swal({ title: "Erro", text: err.message, icon: "error" }); })
        .finally(() => { this.saving = false; });
    },
  },
};
</script>

<style scoped>
.fm { padding: 20px; }
.fm-title { font-size: 16px; font-weight: 600; color: #1d2939; margin-bottom: 16px; }
.fm-label { font-size: 11px; font-weight: 600; color: #667085; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 3px; display: block; }
.fm-input-mono { font-family: 'SF Mono', Consolas, monospace; font-size: 12.5px; }
.fm-help { background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 10px 14px; font-size: 12px; color: #667085; }
.fm-help code { background: #eceaf3; padding: 1px 5px; border-radius: 3px; font-size: 11px; color: #3a3e81; }
.fm-footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px; padding-top: 16px; border-top: 1px solid #e9ecef; }
</style>
